import React, { useRef, useState } from "react";
import styled from "styled-components";

import Popup from "components/ui/Popup";
import { HELP_CONTENT, HelpType } from "./help-components";

const StyledPopup = styled(Popup)``;

const TopBar = styled.div`
  position: relative;
`;

const CloseBtn = styled.button`
  all: unset;
  position: absolute;
  right: 0;
  top: -4px;
  cursor: pointer;
`;

const Title = styled.h2`
  font-size: 18px;
  font-weight: bold;
  color: #222b45;
  margin-bottom: 18px;
`;

const OverflowY = styled.div`
  max-height: 60vh;
  overflow: auto !important;
  overscroll-behavior: contain;
`;

const SectionWrap = styled.div`
  margin-bottom: 28px;
`;

const SectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
`;

const SectionContent = styled.div`
  font-size: 14px;
  color: #6b748b;
  line-height: 1.7;
`;

interface BusinessDashboardHelpHoverCardProps {
  type: HelpType;
  children: React.ReactNode;
}

export const BusinessDashboardHelpHoverCard = ({
  type,
  children,
}: BusinessDashboardHelpHoverCardProps) => {
  const [visible, setVisible] = useState(false);
  const popupRef = useRef<any>(null);

  const contentData = HELP_CONTENT[type];

  if (!contentData) return null;

  const handleOpen = (e: React.MouseEvent) => {
    e.stopPropagation();
    setVisible(true);
  };

  const handleClose = () => setVisible(false);

  const trigger = React.cloneElement(
    React.Children.only(children) as React.ReactElement,
    {
      //@ts-expect-error:__
      onClick: handleOpen,
    }
  );

  return (
    <>
      {trigger}
      {/* @ts-expect-error:__ */}
      <StyledPopup ref={popupRef} open={visible} onClose={handleClose}>
        <TopBar>
          <CloseBtn onClick={handleClose} aria-label="도움말 닫기">
            {/* 닫기 아이콘 SVG */}
            <svg
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.5"
                y="0.5"
                width="27"
                height="27"
                rx="4.5"
                fill="white"
              />
              <rect
                x="0.5"
                y="0.5"
                width="27"
                height="27"
                rx="4.5"
                stroke="#E3E5E8"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.21967 8.21967C8.51256 7.92678 8.98744 7.92678 9.28033 8.21967L14 12.9393L18.7197 8.21967C19.0126 7.92678 19.4874 7.92678 19.7803 8.21967C20.0732 8.51256 20.0732 8.98744 19.7803 9.28033L15.0607 14L19.7803 18.7197C20.0732 19.0126 20.0732 19.4874 19.7803 19.7803C19.4874 20.0732 19.0126 20.0732 18.7197 19.7803L14 15.0607L9.28033 19.7803C8.98744 20.0732 8.51256 20.0732 8.21967 19.7803C7.92678 19.4874 7.92678 19.0126 8.21967 18.7197L12.9393 14L8.21967 9.28033C7.92678 8.98744 7.92678 8.51256 8.21967 8.21967Z"
                fill="#9CA1AB"
              />
            </svg>
          </CloseBtn>
        </TopBar>
        <Title>{contentData.title}</Title>
        <OverflowY>
          {contentData.sections.map((section, idx) => (
            <SectionWrap key={idx}>
              <SectionTitle>{section.subtitle}</SectionTitle>
              <SectionContent>{section.content}</SectionContent>
            </SectionWrap>
          ))}
        </OverflowY>
      </StyledPopup>
    </>
  );
};
